import React,{useState,useEffect,useRef} from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

  import { useRouteMatch,useHistory} from "react-router-dom";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,Timer,AudioLines,
  FolderHeart, Forward,Earth,ListChecks,Gift,Settings,BetweenHorizontalStart,
  ImagePlay,Film,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,ChevronUp,ChevronDown,
  GripHorizontal,
  CopyPlus,
  Bookmark,
  Pencil,
  Trash2,
  Recycle,
  Play,
  Minus,
  ListFilter,
  ListCollapse,
  ListMusic,
  LayoutPanelTop,
  LayoutPanelLeft} from 'lucide-react';
import { getAllProductsByApp } from "../../store/actions/CreateApp/getCoursesByAppToken";
import CourseCard1 from "./CourseCardAll";
import CourseCardNormal from "./CourseCardNormal";
import { createCourseByAdminV2 } from "../../store/actions/CreateCourse/createCourseByAdmin";
 
const MyCourses =({setCurrentAppCourses})=>{



     const dispatch = useDispatch();
         const user = useSelector((state)=>state?.user?.user);
              
         const [snackbarVisible, setSnackbarVisible] = useState(false);
                          const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                          const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                    
                           
                       const showSnackbar = () => {
                         setSnackbarVisible(true);
                       };
                      
                       const hideSnackbar = () => {
                         setSnackbarVisible(false);
                       };
                 
                 
                            
                            
                         
                        const [animate, setAnimate] = useState(false);
          
           const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }

      
      const token = useSelector((state)=>state?.course?.course?.token);
             const currentToken = useSelector((state)=>state?.user?.user?.token);
             const user_email = useSelector((state)=>state?.user?.user?.user_email
            );
            
            const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
            
            const courseData = useSelector((state)=>state?.course?.course);
       
               
               const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
              const appId = useSelector((state)=>state?.app?.app?.ID);
                    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
                        
                
                 const [visibility,setVisibility] =useState("public");
                 const [orderBy,setOrderBy] =useState("ASC");
                 const [itemArr, setItemArr] = useState([]);
                 const [itemReorderArr, setItemReorderArr] = useState([]);
                 
                  const [itemArrLoading, setItemArrLoading] = useState([{},{},{}]);
                 const [itemId, setItemId] = useState("");
                 const [currentItem, setCurrentItem] = useState({});
  const {url}=useRouteMatch();
       
   const history = useHistory();
useEffect((e)=>{
      
    fireGetAllCoursesByApp();
        },[visibility,orderBy,postIdCourse]);
  const fireGetAllCoursesByApp=()=>{
          setItemArr([])
         
       if(!AppToken){history.push(`/apps`)} 
                
          // if(visibility=='public'){setActiveFilterTwo(true)}
          // if(openAppDesignPopUp){setActiveFilterTwo(true);setVisibility('public');}
          
        
          setItemArrLoading([{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{}
        
        setLoader({status:true});
            // console.log({
            //     token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
            //     appToken:AppToken,visibility:visibility,orderBy:orderBy
            //     });
              const apiData = dispatch(getAllProductsByApp({
                      token:AppToken,courseId:postIdCourse ,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                      appToken:AppToken,visibility:visibility,orderBy:orderBy,appId:appId}));
              /* get response as Promise   */
              apiData.then(response => {
                console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.products)  {setItemArr(response?.products); 
        
                 
               
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
           
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                
               if(response?.logout){
               
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
              
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                
                 setItemArrLoading([{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
             
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }



  const handleCreateProduct=(item)=>{
  
  
  
  setLoader({status:true});
     const apiData = dispatch(createCourseByAdminV2({userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:"deleteProduct",postId:item?.ID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
         console.log(response)
        if(response?.course){
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    

  const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 





         return (<>
        <div className="selectThumbImgOuterAll"  style={{zIndex:999999}}>
            
          
            <div  className="ShowOuterPopUpLeft" style={{zIndex:9999999,background:"#ffffff"}}>
            <div onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
                 borderRadius:"50%",float:"right",margin:"10px",
               background:"#958FDA",zIndex:9999999}} onClick={()=>setCurrentAppCourses()}   >
                 <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
                
         <div  className="courseFilterCardsOuter" style={{} }>
            <div></div>
            
         <div className="courseFilterCards"
         >
              {flattenedDataLoading?.length==0?flattenedData?.length?
                         <CourseCardNormal deleteCourseFallback={(v)=>{handleCreateProduct(v)}} appItem={{}} setCurrentAppCourses={()=>{setCurrentAppCourses()}} arrCourseCards={flattenedData}/>:"":""}
            
            </div>
            <div></div>
            </div></div></div></>)

}
export default MyCourses;